import {
  PriceElementPeriodSavingMobileUi,
  PricePlanMobileSwitcherSliderUi,
  PricePlanMobileSwitcherToggleButtonUi,
  PricePlanMobileSwitcherToggleUi,
  PricePlanMobileSwitcherUi,
} from 'common/components/entities/price-element/price-element-period/ui/price-plan-mobile-button'
import {
  PriceElementPeriodSavingUi,
  PriceElementPeriodSwitcherLabelUi,
  PriceElementPeriodSwitcherUi,
  SwitchInputUi,
  SwitchLabelUi,
  SwitchSliderUi,
} from 'common/components/entities/price-element/price-element-period/ui/price-plan-switcher-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export interface PricePlanSwitcherProps {
  isChecked: boolean
  onClick: () => void
}

export const PricePlanSwitcher = ({
  isChecked,
  onClick,
}: PricePlanSwitcherProps) => {
  const { t } = useTranslation()

  return (
    <>
      <PricePlanMobileSwitcherUi>
        <PricePlanMobileSwitcherToggleUi>
          <PricePlanMobileSwitcherToggleButtonUi
            isSelected={!isChecked}
            onClick={onClick}
          >
            {t('components.price_element.period.monthly_billing')}
          </PricePlanMobileSwitcherToggleButtonUi>
          <PricePlanMobileSwitcherSliderUi isActive={isChecked} />
          <PricePlanMobileSwitcherToggleButtonUi
            isSelected={isChecked}
            onClick={onClick}
          >
            {t('components.price_element.period.annual_billing')}
          </PricePlanMobileSwitcherToggleButtonUi>
          <PriceElementPeriodSavingMobileUi isVisible={isChecked}>
            {t('components.price_element.period.additional_text')}{' '}
            {t('components.price_element.period.sub_additional_text')}
          </PriceElementPeriodSavingMobileUi>
        </PricePlanMobileSwitcherToggleUi>
      </PricePlanMobileSwitcherUi>

      <PriceElementPeriodSwitcherUi>
        <PriceElementPeriodSwitcherLabelUi isActive={!isChecked}>
          {t('components.price_element.period.monthly_billing')}
        </PriceElementPeriodSwitcherLabelUi>
        <SwitchLabelUi>
          <SwitchInputUi checked={isChecked} onClick={onClick} />
          <SwitchSliderUi />
        </SwitchLabelUi>
        <PriceElementPeriodSwitcherLabelUi isActive={isChecked}>
          {t('components.price_element.period.annual_billing')}
        </PriceElementPeriodSwitcherLabelUi>

        <PriceElementPeriodSavingUi isVisible={isChecked}>
          {t('components.price_element.period.additional_text')}{' '}
          {t('components.price_element.period.sub_additional_text')}
        </PriceElementPeriodSavingUi>
      </PriceElementPeriodSwitcherUi>
    </>
  )
}
